
    // extracted by mini-css-extract-plugin
module.exports = {"hero":"z0aed3 z4e5d3 z019d4","container":"ze6e92 zb1da4","detailsSection":"zacb8a z4e5d3","placeholder":"z5dfb0","details":"z53ada z013cd z5209f","detailsSectionSticky":"z1b5a0 zacb8a z4e5d3","detailsContainer":"z38afd","detailsBackground":"z80673 z30325","static":"z2e54f","detailsButton":"zea43e","detailsCell":"z31b61"};;
    module.exports = module.exports || {};
    module.exports.toString = function() {
      return JSON.stringify(module.exports)
    };
  